import { makeStyles } from '@material-ui/core/styles';
import { deepOrange, deepPurple } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
    width: 35,
    height: 35,
    marginRight: 10,
  },
  actionIcon: {
    // marginLeft: '1rem',
    // position: 'absolute',
    // left: 0,
    // right: 0,
    // // background: 'red',
    // width: '100%',
    // height: '100%',
  },
}));
export default useStyles;
